import { adminBaseQueryWrapper, customBaseQuery } from "@/utils/rtkHelper";
import { createApi } from "@reduxjs/toolkit/query/react";

export interface supportticket {
    name: string;
    email: string;
    phone: string;
    issue_description: string;
}
export interface ticketSearch {
    startAt: number;
    pageSize: number;
    sortDesc: boolean;
    filter_groups: any[];
    sorting: any[];
}

export interface ticketSearchResult {
    items: supportticket[];
    pageSize: number;
    startAt: number;
    sortDesc: boolean;
    total: number;



}
export interface ReplySupportTicketRequest {
    ticket_id: number;
    message: string;
    document_id?: number | null;
}
export interface ReplySupportTicketResponse {
    message: string;
}

export interface SupportTicketMessage {
    id: number;
    sender_type: "admin" | "user"; // agar future me aur types ho sakte hain to string rakh sakti ho
    user_id: number;
    message: string;
    document_id: number | null;
    created_at: string; // ISO date string
    image_url:string;

}

// Ticket Info
export interface SupportTicket {
    id: number;
    name: string;
    email: string;
    phone: string;
    ticket_status: string;
    created_date: string; // ISO date string
}

// Full API Response
export interface SupportTicketDetailResponse {
    ticket: SupportTicket;
    messages: SupportTicketMessage[];
}
export const SupportTicketApi = createApi({
    reducerPath: "SupportTicketApi",
    baseQuery: customBaseQuery,
    tagTypes: ["support-ticket"],
    keepUnusedDataFor: 0,
    endpoints: (builder) => ({

        uploadPhoto: builder.mutation({
            query: (formData) => ({
                url: `/support-ticket/document`,
                method: "POST",
                body: formData,
            }),
            invalidatesTags: ["support-ticket"],
        }),
        createsupportTicket: builder.mutation<void, any>({
            query: (input) => ({
                url: `/support-ticket/create`,
                method: "POST",
                body: input,
            }),
            invalidatesTags: ["support-ticket"],
        }),
        searchSupportTicket: builder.query<ticketSearchResult, ticketSearch>({
            query: (input) => ({
                url: `/support-ticket/search`,
                method: "POST",
                body: { ...input, export: false },
            }),
            providesTags: ["support-ticket"],
        }),
        exportSupportTicket: builder.mutation<Blob, ticketSearch>({
            query: (input) => ({
                url: `/support-ticket/search`,
                method: "POST",
                body: { ...input, export: true },
                responseHandler: (response: Response) => response.blob(),
            }),
        }),
        getSupportTicketById: builder.query<
            SupportTicketDetailResponse,
            number
        >({
            query: (id) => `/support-ticket/detail/${id}`,
        }),
        replySupportTicket: builder.mutation<
            ReplySupportTicketResponse,
            ReplySupportTicketRequest
        >({
            query: (body) => ({
                url: `/support-ticket/ticket/reply`,
                method: "POST",
                body,
            }),
        }),
        updateSupportTicketStatus: builder.mutation<{ message: string }, { ticket_id: number; ticket_status: string }>({
            query: (body) => ({
                url: `/support-ticket/update-status`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["support-ticket"],
        }),

    }),
});

export const {
    useCreatesupportTicketMutation,
    useUploadPhotoMutation,
    useSearchSupportTicketQuery,
    useExportSupportTicketMutation,
    useGetSupportTicketByIdQuery,
    useReplySupportTicketMutation,
    useUpdateSupportTicketStatusMutation
} = SupportTicketApi;
